import './story-insights.scss';

import StoryInsights from './StoryInsights';

export default StoryInsights;
